import { createReducer } from '@reduxjs/toolkit'
import { uiActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo UI
 */
export const uiReducer = createReducer(initialState, (builder) => {
  builder
    // Add toast
    .addCase(uiActions.addToast, (state, action) => {
      state.toasts.push(action.payload)
    })
    
    // Remove toast
    .addCase(uiActions.removeToast, (state, action) => {
      state.toasts = state.toasts.filter(toast => toast.id !== action.payload)
    })
    
    // Clear all toasts
    .addCase(uiActions.clearToasts, (state) => {
      state.toasts = []
    })
    
    // Helper actions - criar toast automaticamente
    .addCase(uiActions.showSuccess, (state, action) => {
      const id = Math.random().toString(36).substr(2, 9)
      state.toasts.push({
        id,
        type: 'success',
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration || 4000
      })
    })
    
    .addCase(uiActions.showError, (state, action) => {
      const id = Math.random().toString(36).substr(2, 9)
      state.toasts.push({
        id,
        type: 'error',
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration || 4000
      })
    })
    
    .addCase(uiActions.showWarning, (state, action) => {
      const id = Math.random().toString(36).substr(2, 9)
      state.toasts.push({
        id,
        type: 'warning',
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration || 4000
      })
    })
    
    .addCase(uiActions.showInfo, (state, action) => {
      const id = Math.random().toString(36).substr(2, 9)
      state.toasts.push({
        id,
        type: 'info',
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration || 4000
      })
    })
})

